// extracted by mini-css-extract-plugin
export default {"secondary_button":"secondary_secondary_button__U89On"};